"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable implicit-arrow-linebreak */
var NavItem = function NavItem(objectIdType) {
  return {
    parentId: {
      type: objectIdType
    },
    title: {
      type: String
    },
    order: {
      type: Number,
      required: true
    },
    children: [],
    slides: []
  };
};

/**
 * Schema for a Module
 * @param {ObjectId} objectIdType ObjectId type from mongoose package
 * @returns Array with Collection name and defined Schema
 */
var Module = function Module(objectIdType) {
  if (!objectIdType) {
    throw new Error('objectIdType must be provided');
  }
  return ['Module', {
    name: {
      type: String,
      required: true,
      minlength: 1,
      trim: true
    },
    description: {
      type: String
    },
    slides: [{
      type: objectIdType,
      ref: 'Slide'
    }],
    _courseId: {
      type: objectIdType,
      required: true,
      ref: 'Course'
    },
    createdAt: {
      type: Date,
      required: true
    },
    createdBy: {
      type: String
    },
    updatedAt: {
      type: Date
    },
    updatedBy: {
      type: String
    },
    disabledAt: {
      type: Date
    },
    order: {
      type: Number
    },
    active: {
      type: Boolean,
      "default": true
    },
    isPre: {
      type: Boolean,
      "default": false
    },
    isPost: {
      type: Boolean,
      "default": false
    },
    hideExcerptLabel: {
      type: Boolean
    },
    isPublic: {
      type: Boolean
    },
    disableOverlay: {
      type: Boolean
    },
    useCustomNav: {
      type: Boolean
    },
    customNav: {
      title: {
        type: String
      },
      homeLabel: {
        type: String
      },
      navItems: [NavItem(objectIdType)]
    }
  }];
};
var _default = Module;
exports["default"] = _default;